import { Appearance, PrintArea, Size, StoreFont } from '@/types';
import { printTypesFor } from './printTypesFor';

export const printTypesForText = (
  printArea: PrintArea,
  appearance: Appearance,
  font: StoreFont,
  size: Size,
  fontSize: number,
  rotation = 0
) =>
  printTypesFor(
    printArea,
    appearance,
    font.printTypeIds,
    size,
    rotation,
    1,
    fontSize < font.minimalSize,
    true
  );
